import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { parentLinks } from "../../../data/parent-menu";
import { ListItem } from "../list-item/list-item";
import styles from "./how-cinch-works-menu.module.css";
export var HowCinchWorksListItems = function(param) {
    var navItems = param.navItems, handleTrackEvent = param.handleTrackEvent;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: navItems.map(function(listItem) {
            return /*#__PURE__*/ _jsx("li", {
                className: styles.listItem,
                children: /*#__PURE__*/ _jsx(ListItem, {
                    label: listItem.label,
                    ariaLabel: listItem.label,
                    href: listItem.href,
                    handleClickEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            action: listItem.label,
                            label: parentLinks.HOWCINCHWORKS,
                            value: listItem.label
                        });
                    }
                }, listItem.label)
            }, listItem.label);
        })
    });
};
